import { Link, Navigate, useNavigate } from "react-router-dom";
import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { decryptData } from "../_services/encDnc";
import { ClipLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Breadcrumb from "./Breadcrumb";

const UserRegister = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Name: '',
        EmailId: '',
        MobileNo: '',
        Password: '',
        ConfirmPassword: '',
        CreatedBy: 0,
        RoleId: 1
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(pervState => ({
            ...pervState,
            [name]: value
        }));

    };

    const validateName = (name) => {
        const isValid = /^[a-zA-Z\s]{2,50}$/.test(name);
        return isValid;
    };

    const validateEmail = (email) => {
        const isValid = /^[^\s@]+@[^\s@]+\.(com|in|co\.in)$/i.test(email);
        return isValid;
    };

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && /^[0-9]/.test(phone);
        return isValid;
    };

    // const validatePassword = (password) => {
    //     // Ensure password is not empty and matches the pattern
    //     if (!password || password.trim() === '') {
    //         return false;
    //     }
    //     const isValid = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(password);
    //     return isValid;
    // };


    const onRegister = async (e) => {
        e.preventDefault();

        if (!validateName(formData.Name)) {
            toast.error('Please enter Name');
            return;
        }

        if (!validateEmail(formData.EmailId)) {
            toast.error('Please enter a valid Email Address');
            return;
        }

        if (!validatePhoneNumber(formData.MobileNo)) {
            toast.error('Please enter a valid mobile number');
            return;
        }

        // const password = formData.Password;
        // if (!validatePassword(password)) {
        //     toast.error(
        //         'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.'
        //     );
        //     return;
        // }

        if (formData.Password !== formData.ConfirmPassword) {
            toast.error('Password does not match');
            return;
        }

        const formattedMobileNo = `${formData.MobileNo}`;

        const dataToSubmit = {
            ...formData,
            MobileNo: formattedMobileNo
        };

        try {
            setLoading(true)
            const response = await post(API_URL.SaveLoginDetail, dataToSubmit, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            if (response.isSuccess === 200) {
                toast.success('Registration successful!');
                const encryptedData = response?.data;

                const parseData = decryptData(encryptedData);
                const token = response?.token;
                localStorage.setItem('token', token);
                const { isLoggedIn } = parseData;
                localStorage.setItem('isLoggedIn', isLoggedIn);
                localStorage.setItem('user', 'true');
                navigate('/');
                setFormData({
                    Name: '',
                    EmailId: '',
                    MobileNo: '',
                    Password: '',
                    ConfirmPassword: '',
                });
            }
            else {
                alert("You are already registered. Please login.");
                Navigate('/login');
                toast.error('Registration failed');
            }
        } catch (error) {
            toast.error("Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <Header />
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>Register</h1>
                    </div>
                    <Breadcrumb currentLabel="Register" />
                </div>
            </section>
            <section className='userlogin '>
                <div className='all_cente_login'>
                    <div className="container">
                        <div className="row">
                            <div className='col-lg-7'>
                                <div className='form-content'>
                                    <h1>WELCOME to MU Gems Jewellers
                                    </h1>
                                    <p>Discover exclusive designs, timeless elegance, and personalized shopping experiences. Sign in to unlock special offers and track your orders effortlessly</p>
                                </div>
                            </div>
                            <div className='col-lg-5'>
                                <div className='userloginform'>
                                    <div className='userform-heading'>
                                        <h4>Register</h4>
                                    </div>
                                    <form onSubmit={onRegister}>
                                        <div className="row">
                                            <div className='col-lg-12'>
                                                <input
                                                    name="Name"
                                                    className="form-control"
                                                    required=""
                                                    type="text"
                                                    placeholder="Full Name"
                                                    value={formData.Name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='col-lg-12'>
                                                <input
                                                    name="EmailId"
                                                    className="form-control"
                                                    required="" type="email"
                                                    placeholder="Email"
                                                    value={formData.EmailId}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='col-lg-12'>
                                                <input
                                                    type="text"
                                                    name="MobileNo"
                                                    className="form-control"
                                                    placeholder="Mobile Number"
                                                    required=""
                                                    value={formData.MobileNo}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                />
                                            </div>

                                            <>
                                                {/* Password Field */}
                                                <div className="col-lg-12 password_icon" style={{ position: 'relative' }}>
                                                    <input
                                                        type={passwordVisible ? 'text' : 'password'}
                                                        name="Password"
                                                        className="form-control"
                                                        placeholder="Password"
                                                        value={formData.Password}
                                                        onChange={handleChange}
                                                        onFocus={() => setPasswordVisible(false)}
                                                        style={{ paddingRight: '40px' }}
                                                    />
                                                    <span
                                                        onClick={() => setPasswordVisible(!passwordVisible)}

                                                    >
                                                        <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} />
                                                    </span>
                                                </div>

                                                {/* Confirm Password Field */}
                                                <div className="col-lg-12 password_icon" style={{ position: 'relative' }}>
                                                    <input
                                                        type={confirmPasswordVisible ? 'text' : 'password'}
                                                        name="ConfirmPassword"
                                                        className="form-control"
                                                        placeholder="Confirm Password"

                                                        value={formData.ConfirmPassword}
                                                        onChange={handleChange}
                                                        onFocus={() => setConfirmPasswordVisible(false)}
                                                        style={{ paddingRight: '40px' }}
                                                    />
                                                    <span
                                                        onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}

                                                    >
                                                        <FontAwesomeIcon icon={confirmPasswordVisible ? faEyeSlash : faEye} />
                                                    </span>
                                                </div>
                                            </>

                                            <div className='col-lg-12 user-loginbtn'>

                                                <button
                                                    type="submit"
                                                    onClick={onRegister}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <ClipLoader color="#fff" size={20} />
                                                    ) : (
                                                        'Register'
                                                    )}
                                                </button>
                                            </div>
                                            <Toaster position="top-right" />
                                            <div className='userformlinks'>
                                                <span>Already have an account?</span>
                                                <Link className="register_color" to="/login">Login</Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default UserRegister;
